// extracted by mini-css-extract-plugin
export default {"top":"RewardModal_top__8u3s-","backProject":"RewardModal_backProject__1KpBY","support":"RewardModal_support__7SXbv"};